import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { PRICE, TOTAL_VALUE } from '../data/product';
export function Close() {
  return <section className="floodlit-outfield w-full border-y-4 border-clay" data-id="element-85" data-mp="1uycn6jzhvc7w">
      <div className="mx-auto max-w-3xl px-5 py-16 text-center sm:py-20" data-id="element-86" data-mp="1uwi3ta3vfs5x">
        <h2 className="font-display text-3xl text-cream sm:text-5xl" data-id="element-87" data-mp="1pyghmgb5fcq8">
          Stop winging training night. <span className="text-willow" data-id="element-88" data-mp="1l0yi1gj0u9uw">Start running the session.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-cream/80" data-id="element-89" data-mp="1g8dsir75eix6">
          Six volumes, 90 ready-to-run sessions and five bonuses. Your whole
          junior cricket season: three stations, soft-ball and hard-ball tracks,
          rain-ready, with every player batting, bowling or fielding.
        </p>

        <div className="mt-7" data-id="element-90" data-mp="128cgcflfnp2e">
          <Countdown size="sm" data-id="element-91" data-mp="12brv1hb72w3a" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-2xl border border-willow bg-field-deep/60 px-5 py-4 text-left" data-id="element-92" data-mp="xaaw3rc9tjpc">
          <div data-id="element-93" data-mp="40r1nefxwu34">
            <span className="block text-[10px] font-semibold uppercase tracking-widest text-willow" data-id="element-94" data-mp="4197n2semmo8">Complete package</span>
            <span className="text-[15px] font-semibold text-cream" data-id="element-95" data-mp="3lia96y08r2hf">No-Queue Cricket: 6 Volumes + 5 Bonuses</span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-96" data-mp="3qglin7mmjaz4">
            <span className="text-[15px] text-cream/60 line-through" data-id="element-97" data-mp="i08vw9c08zjv">${TOTAL_VALUE}</span>
            <span className="font-display text-4xl font-black leading-none text-cream" data-id="element-98" data-mp="n051ue49j122">${PRICE}</span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-99" data-mp="81je0gk3zf3m">
          <CtaButton data-id="element-100" data-mp="d1ffo95c2ug0">Yes, I want No-Queue Cricket — ${PRICE}</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-cream/65" data-id="element-101" data-mp="d38pfxb8tus8">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-102" data-mp="2xsy0s0cqmyg6">
              <span className="h-1.5 w-1.5 rounded-full bg-willow" data-id="element-103" data-mp="147w84dhxgmph" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}